import { Component, OnInit, Input } from '@angular/core';
import { ReportService } from '../report.service';
import { SharedService } from '../../../shared/shared.service';
import { Logger } from 'angular2-logger/core';

@Component ({
  selector: 'app-report-pie',
  templateUrl: './report-pie.component.html',
  styleUrls: ['./report-pie.component.scss']
})
export class ReportPieComponent implements OnInit {
  // Pie
  public pieChartLabels: string[] = ['Tickets Attendes', 'Tickets in Wait', 'Tickets Close'];
  public pieChartData: number[] = [300, 500, 100];
  public pieChartType: string = 'pie';
  @Input() public info: any;
  public type_report: string;
  public state_report: Array<number>;
  public date_start_report: string;
  public date_end_report: string;
  public date: string;

  constructor(
    private _reportService: ReportService,
    private _sharedService: SharedService,
    private logger: Logger) {
  }

/*  pointClickHandler(e) {
    this.toggleVisibility(e.target);
}

legendClickHandler (e) {
    const arg = e.target, item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];

    this.toggleVisibility(item);
}

toggleVisibility(item) {
    if (item.isVisible()) {
        item.hide();
    } else {
        item.show();
    }
}*/

customizeLabel(arg) {
  let percent_truncate = (arg.percent * 100).toFixed(1);
    return arg.argumentText + ': ' + arg.valueText + ' (' + percent_truncate + '%' + ')' + '';
}

customizeTooltip(arg) {
  let percent_truncate = (arg.percent * 100).toFixed(1);
  return { text: arg.argumentText + "<br>" + percent_truncate + "%" };
}

  ngOnInit() {
    //this.dataReport();
  }

  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/report/report-pie/report-pie.component.ts